import React, { useContext, useMemo } from 'react';
import { createPortal } from 'react-dom';
import styled, { css } from 'styled-components';
import OverlayComponent from './Overlay.component';
import { StyledSpinnerView } from './Spinner.component';

export interface PortalProps extends React.AllHTMLAttributes<HTMLDivElement> {
  onClose?: Function;
  withOverlay?: boolean;
  modalStyle?: any;
  position?: 'manual' | 'center' | 'right-bottom';
  disableClose?: boolean;
}

const StyledPortalWrapperRightBottom = css`
  position: absolute;
  right: 20px;
  bottom: 20px;
`;

const StyledPortalWrapperRightTop = css`
  position: absolute;
  right: 20px;
  top: 20px;
`;

const StyledPortalWrapperCenter = css`
  max-height: 100vh;
`;
export const StyledPortalWrapper = styled.div<{
  position: string;
  isLinkedin: boolean;
}>`
  ${props => props.position === 'center' && StyledPortalWrapperCenter};
  ${props =>
    props.position === 'right-bottom' && StyledPortalWrapperRightBottom};
  ${props => props.position === 'right-top' && StyledPortalWrapperRightTop};

  ${({ isLinkedin, theme }) =>
          isLinkedin &&
          `
    input, select, textarea {
      all: unset;
      border: none !important;
      outline: none !important;
      box-shadow: none !important;
      background: none;
      color: black;
      font-family: Arial;
      width: 100%;
      height: 18px;
    }
    
    input {
      padding: 1px 0px;
    }
    
    textarea {
      padding: 2px;
    }
    input:focus, select:focus, textarea:focus {
      outline: none !important;
      box-shadow: none !important;
      border: none !important;
    }
    
    input:active {
      background-color: inherit;
    }
    
    input:disabled {
      background-color: inherit;
      color: black;
      opacity: 0.65;
    }
    
    
    textarea {
      min-height: 200px;
    }
    
    label {
      color: ${theme.colors.TITLE};
      font-weight: 500;
    }
    
    div[role="option"] {
      line-height: 1.5;
    }
    
    line-height: 1;
    font-size: 14px;
    color: ${theme.colors.TITLE};
    box-sizing: content-box;
`}

  font-weight: 400;
`;
const StyledPortal = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PortalTargetContext = React.createContext<() => HTMLElement | null>(() => document.getElementById('portal')!);

const PortalComponent = ({
  position = 'center',
  children,
  withOverlay = true,
  modalStyle = {},
  onClose,
  disableClose,
}: PortalProps) => {
  const getPortal = useContext(PortalTargetContext);
  const portal = useMemo(() => getPortal(), [getPortal]);
  const isLinkedin = window.location.origin.includes('linkedin');

  if (!portal) return null;

  return createPortal(
    <StyledPortal
      style={modalStyle}
      onClick={() => (!withOverlay ? onClose && onClose() : undefined)}
    >
      {withOverlay && (
        <OverlayComponent handleClick={() => !disableClose && onClose && onClose()} />
      )}
      <StyledPortalWrapper position={position}  isLinkedin={isLinkedin}>{children}</StyledPortalWrapper>
    </StyledPortal>,
    portal,
  );
};

export default PortalComponent;
